module.exports = __webpack_public_path__ + "static/media/MyAsset.9bb341d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/MyAsset.png
// module id = 732
// module chunks = 0 1